import { useAuthStore } from '../store/authStore.js';
import { usarModo } from '../store/deviceModeStore.js';

// Permisos del punto de venta.
//
// Hasta ahora el POS guardaba el rol y no lo leía nadie: en cualquier tablet,
// un operador podía hacer devoluciones y sacar efectivo del cajón. El control
// de verdad está en el servidor —esconder un botón no protege nada, el POS es
// un cliente y un cliente se modifica—; esto es para que la pantalla no le
// ofrezca a alguien algo que le va a rebotar con un 403.

const JERARQUIA = ['operador', 'gerente', 'admin'];

const alMenos = (rol, minimo) =>
  JERARQUIA.indexOf(rol) >= JERARQUIA.indexOf(minimo);

/**
 * Qué puede hacer quien está usando la caja ahora mismo.
 *
 * `cobrar` es el único que depende del negocio y no solo del rol: con cobro
 * centralizado el operador levanta órdenes pero no cierra cuentas. Es un
 * ajuste porque los dos casos son reales — el restaurante con caja quiere la
 * separación, el food truck de una persona no puede permitírsela.
 */
export const usarPermisos = () => {
  const rol    = useAuthStore((s) => s.user?.role) ?? 'operador';
  const tenant = useAuthStore((s) => s.tenant);

  const modo = usarModo();

  const cobroCentralizado = Boolean(tenant?.posCentralizedCharge);
  const comandera = modo === 'comandera';

  // En comandera no es cuestión de permisos: sin sesión de caja no hay
  // `session_id` que mandar, así que un cobro no se puede ni armar. Lo mismo
  // con devoluciones y el corte, que son operaciones sobre un turno.
  return {
    rol,
    comandera,
    esGerente:   alMenos(rol, 'gerente'),
    devolver:    !comandera && alMenos(rol, 'gerente'),
    moverCaja:   !comandera && alMenos(rol, 'gerente'),
    cerrarCaja:  !comandera,
    cobrar:      !comandera && (alMenos(rol, 'gerente') || !cobroCentralizado),
    cobroCentralizado,
  };
};

export default usarPermisos;
